import {
  Component,
  forwardRef,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import { ServiceStackTypeVersion } from '@zerops/models/service-stack';
import { ServiceStackVersionFieldTranslations } from './service-stack-version-field.translations';

@Component({
  selector: 'z-service-stack-version-field',
  templateUrl: './service-stack-version-field.component.html',
  styleUrls: [ './service-stack-version-field.component.scss' ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ServiceStackVersionFieldComponent),
      multi: true
    }
  ]
})
export class ServiceStackVersionFieldComponent implements ControlValueAccessor {

  @Input()
  items: ServiceStackTypeVersion[];

  @Input()
  translations: ServiceStackVersionFieldTranslations;

  @Output()
  versionSelected = new EventEmitter<string>();

  set value(v) {
    this._value = v;

    this._propagateChange(this.value);
  }

  get value() {
    return this._value;
  }

  private _value: string;

  writeValue(val: string) {
    this.value = val;
  }

  registerOnChange(fn: any) {
    this._propagateChange = fn;
  }

  registerOnTouched(_: any) {
    return;
  }

  private _propagateChange = (_: any) => {
    return;
  };

  trackBy(index: number) {
    return index;
  }
}
